import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FoxTrader from "./../../../Images/foxtrader.png";
import "./AlgoBullsDownload.css";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';

function AlgoBullsDownload() {
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

           // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://app.algobulls.com/user/login',
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  return (
    <>
      <section className="fox-download">
        <Container>
          <Row>
            <Col md={5}>
              <div className="fox-download-img">
                <img className="img-fluid" src={FoxTrader} alt="FoxTrader" />
              </div>
            </Col>
            <Col md={7}>
              <div>
                <h3> AlgoBulls</h3>
                <p>
                AlgoBulls is a Web and Android based platform. To begin with AlgoBulls, download and set up your account by filling all the required information. After successful authentication, AlgoBulls is ready for use.
                </p>
                          </div>
                          <div>
                              <button type="button" onClick={() => clickToggleLoginPopup(true)}  className="Login-Button-fox w-50 startnow_btn end-0">
                                   Get Started
                              </button>
                          </div>  
            </Col>
                  </Row>
                  <LoginPopup show={show} ref={childRef} />
              </Container>

      </section>
    </>
  );
}
export default AlgoBullsDownload;
